const Dashboard = () => {
    return (
        <div className="dashboard">
            <div>Bill is a cat.</div>
        </div>
    );
};

export default Dashboard;
